// Angular
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

// services
import { ApiService } from '@app/services/api/api.service';
import { ThemeService } from '@app/services/theme/theme.service';

@Component({
  selector: 'oh-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private agentData: any;
  private token: any;
  public form: FormGroup;
  public loginError: any;
  public loading: boolean;
  public isOnline: boolean;

  constructor(fb: FormBuilder, private apiService: ApiService, private router: Router, private themeService: ThemeService) {
    this.form = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.isOnline = navigator.onLine;
  }

  get valid() {
    return this.form.valid;
  }

  get value() {
    return this.form.value;
  }

  private async getData(token: string) {
    try {
      this.agentData = await this.apiService.getAgentData(token);
    } catch (error) {
      console.log(error);
    }

    try {
      await this.apiService.saveAgentDataToDatabase(this.agentData);
    } catch (error) {
      console.log(error);
    }
  }

  private async loginAndSaveToken() {
    const response = await this.apiService.login(this.value);
    this.token = response.auth_token;
    this.apiService.saveTokenToDatabase(this.token);
    // this.apiService.savePINToDatabase(this.form.value.pin);
  }

  private handleError(error: any) {
    if (error && error.error && error.error.message) {
      this.loginError = error.error.message;
    } else {
      console.log(error);
    }

    if (this.isOnline === false) {
      this.loginError = 'You must be online to login.';
    }
  }

  public async login() {
    this.isOnline = navigator.onLine;
    this.loginError = null;
    this.loading = true;

    try {
      await this.loginAndSaveToken();
      await this.getData(this.token);

      this.themeService.init(this.agentData);
      this.router.navigate(['/open-house-select']);
    } catch (error) {
      this.handleError(error);
    }

    this.loading = false;
  }
}
